import axios from 'axios';
import {jwtDecode} from 'jwt-decode';

axios.defaults.baseURL = window.env.API_URL;


interface MyToken {
  exp: number;
}

//  LOGIN
export async function login(username: string, password: string) {
  const payload = new FormData();
  payload.append('email', username);
  payload.append('password', password);


  try {
      const response = await axios.post("auth/token/", payload, {
          headers: { "Content-Type": "multipart/form-data" }
      });
      if (response.data) {
          localStorage.setItem("refresh", response.data.refresh);
      }
      return response.data;
  } catch (error) {
      console.error("Login failed");
      throw error;
  }
}

//  IS LOGGED IN
interface MyToken {
  exp: number;
  iat: number;
}

export function isLoggedIn(access: string | null) {
  if (!access) return false;
  try {
    const decoded: MyToken = jwtDecode(access);
    return Number.isFinite(decoded.exp) && Date.now() / 1000 < decoded.exp - 60;
  } catch {
    return false;
  }
}

//  LOGOUT
export function logout() {
  localStorage.clear();
}

//  GET PROFILE
export async function getProfile(access: string) {
  if (access) {
      try {
          const response = await axios.get("profile/", {
              headers: { 'Authorization': `Bearer ${access}` }
          });
          const userData = response.data;
          return userData;
      } catch (error) {
          console.error("Failed to fetch profile");
          throw error;
      }
  }
}

//  REFRESH TOKEN
export async function refreshToken() {
  const refresh = localStorage.getItem('refresh');
  if (!refresh) throw Object.assign(new Error('Sign in again to continue.'), { response: { status: 401 } });
  const response = await axios.post('auth/token/refresh/', { refresh });
  if (typeof response.data?.access !== 'string' || !response.data.access) {
    throw Object.assign(new Error('The authentication response was invalid.'), { response: { status: 502 } });
  }
  // SimpleJWT may return only access when refresh-token rotation is disabled.
  return response.data;
}
